'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('./util');

var _KeyboardHoverOnlyDiv = require('../utils/KeyboardHoverOnlyDiv');

var _KeyboardHoverOnlyDiv2 = _interopRequireDefault(_KeyboardHoverOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

function isExist(e) {
  return e !== undefined && e !== null;
}

function isNumber(num) {
  var number = Number(num); //Number function convert "" to zero
  return isExist(num) && num !== "" && !isNaN(number) && (!!number || number === 0);
}

var InputNumber = function (_Component) {
  _inherits(InputNumber, _Component);

  function InputNumber(props) {
    _classCallCheck(this, InputNumber);

    var _this = _possibleConstructorReturn(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call(this, props));

    _initialiseProps.call(_this);

    var value = _this.checkValueMinMax(props.value);
    _this.state = {
      value: isNumber(value) ? value.toString() : _this.defaultValue,
      focused: false
    };
    return _this;
  }

  _createClass(InputNumber, [{
    key: 'getInstructionIcon',
    value: function getInstructionIcon(key) {
      var INSTRUCTION_ICONS = {
        'default-increase-icon': 'appkiticon icon-plus-fill',
        'default-decrease-icon': 'appkiticon icon-minus-fill',
        'separate-increase-icon': 'appkiticon icon-plus-fill',
        'separate-decrease-icon': 'appkiticon icon-minus-fill',
        'arrow-increase-icon': 'appkiticon icon-up-chevron-fill',
        'arrow-decrease-icon': 'appkiticon icon-down-chevron-fill'
      };

      var isDecrease = key.includes("decrease");
      var isIncrease = key.includes("increase");

      var extraCn = void 0;
      if (isDecrease) {
        extraCn = this.props.decreaseIconClassName || "";
      } else if (isIncrease) {
        extraCn = this.props.increaseIconClassName || "";
      }
      var cn = (0, _classnames2.default)(INSTRUCTION_ICONS[key], extraCn);
      return _react2.default.createElement('span', { className: cn });
    }
  }, {
    key: 'checkValueMinMax',
    value: function checkValueMinMax(value) {
      var result = value;
      if (isNumber(this.props.min)) {
        result = Math.max(Number(this.props.min), result);
      }
      if (isNumber(this.props.max)) {
        result = Math.min(Number(this.props.max), result);
      }
      return result;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.value !== this.props.value && isNumber(props.value)) {
        this.setState({ value: props.value.toString() });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$kind = _props.kind,
          kind = _props$kind === undefined ? 'default' : _props$kind,
          _props$inputBoxSize = _props.inputBoxSize,
          inputBoxSize = _props$inputBoxSize === undefined ? 'sm' : _props$inputBoxSize,
          step = _props.step,
          min = _props.min,
          disabled = _props.disabled,
          max = _props.max,
          readonly = _props.readonly,
          onChange = _props.onChange,
          integerOnly = _props.integerOnly,
          style = _props.style,
          className = _props.className,
          _props$inputAttr = _props.inputAttr,
          inputAttr = _props$inputAttr === undefined ? {} : _props$inputAttr,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          others = _objectWithoutProperties(_props, ['kind', 'inputBoxSize', 'step', 'min', 'disabled', 'max', 'readonly', 'onChange', 'integerOnly', 'style', 'className', 'inputAttr', 'onFocus', 'onBlur']);

      var value = this.state.value;

      //a-input-size-lg a-input-size-sm
      //a-input-number-arrow, a-input-number-default, a-input-number-seperate

      var inputNumberWrapperClasses = (0, _classnames2.default)('a-input-number-wrapper', 'a-input-size-' + inputBoxSize, 'a-input-number-' + kind, className, { 'focused': this.state.focused });
      var inputNumberClasses = (0, _classnames2.default)('a-input-text a-input-number');
      var disableIncreaseIcon = disabled || +this.state.value + step > max;
      var disableDecreaseIcon = disabled || +this.state.value - step < min;

      return _react2.default.createElement(
        'div',
        Object.assign({ className: inputNumberWrapperClasses, style: style }, others),
        _react2.default.createElement('input', Object.assign({
          className: inputNumberClasses,
          value: value,
          min: min,
          max: max,
          onKeyDown: this.onKeyDown,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          type: 'text',
          readOnly: readonly,
          disabled: disabled
        }, inputAttr)),
        [_react2.default.createElement(
          _KeyboardHoverOnlyDiv2.default,
          {
            isButton: true,
            className: 'a-increase-icon a-instruction-icon',
            onClick: this.increaseNumber,
            key: 'key-for-inputnumber-increase-icon',
            disabled: disableIncreaseIcon
          },
          this.getInstructionIcon(kind + '-increase-icon')
        ), _react2.default.createElement(
          _KeyboardHoverOnlyDiv2.default,
          {
            isButton: true,
            className: 'a-decrease-icon a-instruction-icon',
            onClick: this.decreaseNumber,
            key: 'key-for-inputnumber-decrease-icon',
            disabled: disableDecreaseIcon
          },
          this.getInstructionIcon(kind + '-decrease-icon')
        )]
      );
    }
  }, {
    key: 'defaultValue',
    get: function get() {
      return this.checkValueMinMax(0).toString();
    }
  }, {
    key: 'isValid',
    get: function get() {
      return isNumber(this.state.value);
    }
  }, {
    key: 'minDisabled',
    get: function get() {
      return !this.isValid || Number(this.state.value) - Number(this.props.step) < Number(this.props.min);
    }
  }, {
    key: 'maxDisabled',
    get: function get() {
      return this.state.value !== "" && (!this.isValid || Number(this.state.value) + Number(this.props.step) > Number(this.props.max));
    }

    // precision is now set inside the InputNumber Component.
    // if user wants a precision prop to control in the future, reuse this part.

  }]);

  return InputNumber;
}(_react.Component);

InputNumber.defaultProps = {
  step: 1,
  max: Infinity,
  min: 0,
  value: 0,
  integerOnly: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onBlur = function () {
    var value = _this2.state.value;
    if (_this2.isValid) {
      value = _this2.checkValueMinMax(Number(value));
    }
    _this2.setState({ value: value.toString() }, _this2.onChange);
  };

  this.onKeyDown = function (e) {
    switch (e.keyCode) {
      case 38:
        // KeyUp
        e.preventDefault();
        _this2.increaseNumber();
        break;
      case 40:
        // KeyDown
        e.preventDefault();
        _this2.decreaseNumber();
        break;
      default:
        break;
    }
  };

  this.handleChange = function (e) {
    var input = e.target.value;
    var hasWord = /[^\d\-.]/.exec(input);
    var invalid = hasWord || _this2.props.integerOnly && input.toString().indexOf(".") > -1;
    if (!_this2.props.disabled && !invalid) {
      var _value = _this2.defaultValue;
      if (isNumber(input)) {
        _value = input.toString();
      } else if (input === "" || input === "-" || input === "." && !_this2.props.integerOnly) {
        _value = input;
      }

      _this2.setState({
        value: _value
      }, function () {
        clearTimeout(_this2.timeout);

        _this2.timeout = setTimeout(function () {
          _this2.onBlur();
        }, 750);
      });
    }
  };

  this.handleFocus = function (e) {
    _this2.setState({
      focused: true
    });
    var onFocus = _this2.props.onFocus;

    onFocus && onFocus(e);
  };

  this.handleBlur = function (e) {
    _this2.setState({
      focused: false
    });
    var onBlur = _this2.props.onBlur;

    onBlur && onBlur(e);
  };

  this.onChange = function () {
    if (_this2.props.onChange) {
      _this2.props.onChange(Number(_this2.state.value));
    }
  };

  this.getPrecision = function (value) {
    if (!value) return 0;
    if (value.indexOf('e-') >= 0) {
      return parseInt(value.slice(value.indexOf('e-') + 2), 10);
    }
    if (value.indexOf('.') >= 0) {
      return value.split('.')[1].length;
    }
    return 0;
  };

  this.getMaxPrecision = function () {
    var stepPrecision = _this2.getPrecision('' + _this2.props.step);
    var currValPrecision = _this2.getPrecision(_this2.state.value);
    return Math.max(stepPrecision, currValPrecision);
  };

  this.increaseNumber = function (e) {
    var _props2 = _this2.props,
        step = _props2.step,
        max = _props2.max,
        disabled = _props2.disabled,
        min = _props2.min;

    var precision = _this2.getMaxPrecision();
    var value = Number(_this2.state.value);
    if (!disabled && !_this2.maxDisabled) {
      if (_this2.state.value === "") {
        value = _this2.props.min;
      } else {
        if (value + Number(step) > Number(max)) {
          return;
        }
        if (value + Number(step) < Number(min)) {
          value = Number(min) - Number(step);
        }
        value = (0, _util.add)(value, Number(step));
      }
      _this2.setState({ value: value.toFixed(precision) }, _this2.onChange);
    }
    e && typeof e.preventDefault === "function" && e.preventDefault();
  };

  this.decreaseNumber = function (e) {
    var _props3 = _this2.props,
        step = _props3.step,
        min = _props3.min,
        disabled = _props3.disabled,
        max = _props3.max;

    var precision = _this2.getMaxPrecision();
    var value = Number(_this2.state.value);

    if (!disabled && !_this2.minDisabled) {
      if (value - Number(step) < Number(min)) {
        return;
      }
      if (value - Number(step) > Number(max)) {
        value = Number(max) + Number(step);
      }
      value = (0, _util.sub)(value, Number(step));
      _this2.setState({ value: value.toFixed(precision) }, _this2.onChange);
    }
    e && typeof e.preventDefault === "function" && e.preventDefault();
  };
};

InputNumber.propTypes = {
  inputBoxSize: _propTypes2.default.oneOf(["sm", "lg"]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  step: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  kind: _propTypes2.default.oneOf(["default", "arrow", "separate"]),
  integerOnly: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  readonly: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  inputAttr: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  increaseIconClassName: _propTypes2.default.string,
  decreaseIconClassName: _propTypes2.default.string
};

exports.default = InputNumber;